import { Descriptions, Button, Modal, Input, Form, TimePicker } from "antd";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { authAction } from "hooks/actions/mainAction";

const backend = process.env.REACT_APP_BACKEND;

function CompensationSetting({ timeSetting, timeHandler }) {
  const dispatch = useDispatch();
  const [modal, setModal] = useState([false,"",""]);
  const compensationRef = useRef(null);

  const modalHandler = (key,name) => {
    setModal([true,key,name])
  }
  const editOkHandler = () => {
    compensationRef.current.validateFields()
    .then(data =>{
      // console.log(data)
      const newTimeSetting = Object.assign({},timeSetting)
      newTimeSetting[modal[1]] = Number(data.name)

      axios
      .post(`${backend}/general_setting/time_setting`, { value:newTimeSetting })
      .then((data) => {

        timeHandler(newTimeSetting)
        setModal([false,"",""])
      })
      .catch(err=>{
        if (err.response.status === 401) {
          Modal.error({
            title: "인증 에러",
            content: "인증이 만료되었습니다. 다시 로그인 해주세요.",
            afterClose: () => {
              dispatch(authAction(false, null));
            },
          });
        }
        console.log(err);
      })
      

    })
    .catch(err =>{
      console.log(err)
    })
  };

  return (
    <div>
      <Modal
        open={modal[0]}
        destroyOnClose={true}
        title="보상 설정"
        maskClosable={false}
        onCancel={() => {
          setModal([false,"",""]);
        }}
        footer={
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <Button onClick={() => compensationRef.current.resetFields()}>
              내용 초기화
            </Button>
            <span>
              <Button type="primary" onClick={editOkHandler}>
                수정
              </Button>
              <Button
                onClick={() => {
                  setModal([false,"",""]);
                }}
              >
                취소
              </Button>
            </span>
          </div>
        }
      >
        <Form
          ref={compensationRef}
          layout="vertical"
          initialValues={{
            name:
              timeSetting[modal[1]],
          }}
        >
          <Form.Item
            name="name"
            label={modal[2]}
            rules={[{ required: true, message: "입력값은 필수입니다." }]}
          >
            <Input type={"number"} />
          </Form.Item>
        </Form>
      </Modal>

      <Descriptions column={1} bordered={true} style={{ width: 500 }}>
        <Descriptions.Item
          label="경험치 지급률(%)(세션 최초 완료 이전)"
          style={{ textAlign: "left" }}
        >
          <span style={{ marginRight: "10px" }}>{timeSetting.experience_giving_rate_before}%</span>
          <Button size="small" onClick={()=>modalHandler("experience_giving_rate_before","경험치 지급률(%)(세션 최초 완료 이전)")}>
            변경
          </Button>
        </Descriptions.Item>

        <Descriptions.Item
          label="경험치 지급률(%)(세션 최초 완료 이후)"
          style={{ textAlign: "left" }}
        >
          <span style={{ marginRight: "10px" }}>{timeSetting.experience_giving_rate_after}%</span>
          <Button size="small" onClick={()=>modalHandler("experience_giving_rate_after","경험치 지급률(%)(세션 최초 완료 이후)")}>변경</Button>
        </Descriptions.Item>

        <Descriptions.Item
          label="보석 지급률(%)(세션 최초 완료 이전)"
          style={{ textAlign: "left" }}
        >
          <span style={{ marginRight: "10px" }}>{timeSetting.gem_giving_rate_before}%</span>
          <Button size="small" onClick={()=>modalHandler("gem_giving_rate_before","보석 지급률(%)(세션 최초 완료 이전)")}>변경</Button>
        </Descriptions.Item>

        <Descriptions.Item
          label="보석 지급률(%)(세션 최초 완료 이후)"
          style={{ textAlign: "left" }}
        >
          <span style={{ marginRight: "10px" }}>{timeSetting.gem_giving_rate_after}%</span>
          <Button size="small" onClick={()=>modalHandler("gem_giving_rate_after","보석 지급률(%)(세션 최초 완료 이후)")}>변경</Button>
        </Descriptions.Item>

        <Descriptions.Item
          label="리스닝 대비 스피킹 경험치 지급 배수(배)"
          style={{ textAlign: "left" }}
        >
          <span style={{ marginRight: "10px" }}>{timeSetting.more_speaking_experience_than_listening}배</span>
          <Button size="small" onClick={()=>modalHandler("more_speaking_experience_than_listening","리스닝 대비 스피킹 경험치 지급 배수(배)")}>변경</Button>
        </Descriptions.Item>

        <Descriptions.Item
          label="리스닝 대비 스피킹 보석 지급 배수(배)"
          style={{ textAlign: "left" }}
        >
          <span style={{ marginRight: "10px" }}>{timeSetting.more_speaking_gem_than_listening}배</span>
          <Button size="small" onClick={()=>modalHandler("more_speaking_gem_than_listening","리스닝 대비 스피킹 보석 지급 배수(배)")}>변경</Button>
        </Descriptions.Item>

        <Descriptions.Item
          label="레벨당 필요 경험치(XP)"
          style={{ textAlign: "left" }}
        >
          <span style={{ marginRight: "10px" }}>{timeSetting.required_experience_per_level.toLocaleString()}XP</span>
          <Button size="small" onClick={()=>modalHandler("required_experience_per_level","레벨당 필요 경험치(XP)")}>변경</Button>
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
}

export default CompensationSetting;
